document.addEventListener('DOMContentLoaded', function () {
    const productGrid = document.querySelector('.collection-product-grid-block');
    const gridItems = document.querySelectorAll('.block__collection-grid-view li');

    if (productGrid && gridItems.length > 0) {
        const isMobile = window.innerWidth <= 749;
        const targetGrid = isMobile ? 'grid-view-big' : 'grid-view-medium';

        const targetItem = document.querySelector(`.block__collection-grid-view li[data-grid="${targetGrid}"]`);
        if (targetItem) {
            targetItem.classList.add('active');
        }

        productGrid.className = productGrid.className.replace(/\bgrid-view-\w+\b/g, '').trim();
        productGrid.classList.add(targetGrid);
    }
});

document.addEventListener('click', function (e) {
    const gridItem = e.target.closest('.block__collection-grid-view li');
    if (!gridItem) return;

    const gridItems = document.querySelectorAll('.block__collection-grid-view li');
    const productGrid = document.querySelector('.collection-product-grid-block');

    if (productGrid) {
        gridItems.forEach(el => el.classList.remove('active'));
        gridItem.classList.add('active');

        const gridClass = gridItem.getAttribute('data-grid');
        if (gridClass) {
            productGrid.className = productGrid.className.replace(/\bgrid-view-\w+\b/g, '').trim();
            productGrid.classList.add(gridClass);
        }
    }
});

let isInProgress = false;

window.addEventListener('scroll', function () {
    if (!isInProgress) {
        const serviceSection = document.querySelector('.footer') || document.querySelector('.product-grid');
        if (!serviceSection) return;

        const scrollPosition = window.pageYOffset + window.innerHeight;
        const offsetTop = serviceSection.getBoundingClientRect().top + window.pageYOffset;

        // Trigger point: we either hit footer or offset is similar
        const targetOffset = offsetTop + (document.querySelector('.footer') ? 0 : serviceSection.offsetHeight);

        if (scrollPosition >= targetOffset) {
            const totalPagesEl = document.querySelector('[data-total-pages]');
            const currentPageEl = document.querySelector('[data-current-page]');
            const nextUrlEl = document.querySelector('[data-next-url]');

            if (!totalPagesEl || !currentPageEl || !nextUrlEl) return;

            const totalPages = parseInt(totalPagesEl.value, 10);
            let currentPage = parseInt(currentPageEl.value, 10);

            if (currentPage >= totalPages) return;

            currentPage = currentPage + 1;
            const nextUrl = nextUrlEl.value.replace(/page=[0-9]+/, 'page=' + currentPage);
            currentPageEl.value = currentPage;

            isInProgress = true;
            const loaderWrap = document.querySelector('.collection-loader-wrap');
            if (loaderWrap) loaderWrap.classList.add('show');

            setTimeout(function () {
                fetch(nextUrl)
                    .then(response => response.text())
                    .then(html => {
                        const tempDiv = document.createElement('div');
                        tempDiv.innerHTML = html;
                        const newGridHtml = tempDiv.querySelector('.product-grid');
                        const currentGrid = document.querySelector('.product-grid');

                        if (newGridHtml && currentGrid) {
                            currentGrid.insertAdjacentHTML('beforeend', newGridHtml.innerHTML);
                        }
                    })
                    .catch(error => console.error('Error fetching pagination:', error))
                    .finally(() => {
                        isInProgress = false;
                        if (loaderWrap) loaderWrap.classList.remove('show');
                    });
            }, 500);
        }
    }
});
